// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__cRsLO {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.styles_timezoneList__Smth6 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.styles_applyAllSection__xDFWa {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--strokes-blue);
}

.styles_applyAllButton__5ubPN {
  font: var(--typography-body-s-medium);
}

.styles_courseTimezoneRow__0oZll {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: var(--color-bg-light-blue);
  border: 1px solid var(--strokes-blue);
  border-radius: 10px;
  transition: all 0.2s ease;
  position: relative;
  overflow: visible;
}
@media (min-width: 768px) {
  .styles_courseTimezoneRow__0oZll {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
}

.styles_dropdownContainer__YhMNh {
  width: 100%;
  flex-shrink: 0;
}
@media (min-width: 768px) {
  .styles_dropdownContainer__YhMNh {
    width: 280px;
    flex-shrink: 0;
  }
}

.styles_courseInfo__cX1cA {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
}

.styles_courseName__G-uzb {
  margin: 0;
  font: var(--typography-body-m-medium);
  color: var(--color-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_timezoneSelect__CL8jc {
  width: 100%;
  padding: 10px 12px;
  font: var(--typography-body-m-regular);
  color: var(--color-black);
  background-color: var(--color-white);
  border: 1px solid var(--strokes-blue);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}
@media (min-width: 768px) {
  .styles_timezoneSelect__CL8jc {
    min-width: 260px;
    width: auto;
  }
}
.styles_timezoneSelect__CL8jc:hover:not(:disabled) {
  border-color: var(--color-accent-blue);
  background-color: rgba(255, 255, 255, 0.5);
}
.styles_timezoneSelect__CL8jc:focus, .styles_timezoneSelect__CL8jc:focus-visible {
  outline: none;
  border-color: var(--color-accent-blue);
  box-shadow: 0 0 0 3px rgba(91, 130, 243, 0.1);
}
.styles_timezoneSelect__CL8jc:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--color-bg-light-blue);
}

.styles_timezoneOption__coh2g {
  padding: 8px;
  font: var(--typography-body-s-regular);
}

.styles_formActions__yImUJ {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_formActions__yImUJ {
    gap: 16px;
    margin-top: 16px;
  }
}

.styles_confirmButton__pKc9f {
  width: 100%;
}

.styles_skipButton__X-8OZ {
  width: 100%;
}

.styles_loading__pLxc2 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_emptyState__hqI1j {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  gap: 16px;
  padding: 40px 20px;
}

.styles_emptyStateText__rdT1x {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_helperText__Ij5tv {
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
  margin-top: 8px;
  text-align: center;
}
@media (min-width: 768px) {
  .styles_helperText__Ij5tv {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/timezone-selection/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAAJ;;AAGE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAGE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AAAJ;;AAGE;EACE,qCAAA;AAAJ;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,4CAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;AC/BE;EDqBA;IAaI,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,aAAA;EACJ;AACF;;AAGE;EACE,WAAA;EACA,cAAA;AAAJ;AC5CE;ED0CA;IAKI,YAAA;IACA,cAAA;EACJ;AACF;;AAEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEE;EACE,SAAA;EACA,qCAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,yBAAA;EACA,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;AACJ;ACjFE;EDsEA;IAaI,gBAAA;IACA,WAAA;EAEJ;AACF;AAAI;EACE,sCAAA;EACA,0CAAA;AAEN;AACI;EAEE,aAAA;EACA,sCAAA;EACA,6CAAA;AAAN;AAGI;EACE,YAAA;EACA,mBAAA;EACA,4CAAA;AADN;;AAME;EACE,YAAA;EACA,sCAAA;AAHJ;;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAHJ;ACjHE;EDgHA;IAOI,SAAA;IACA,gBAAA;EAFJ;AACF;;AAKE;EACE,WAAA;AAFJ;;AAKE;EACE,WAAA;AAFJ;;AAME;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sCAAA;EACA,kCAAA;AAHJ;;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAJJ;;AAOE;EACE,sCAAA;EACA,kCAAA;AAJJ;;AAQE;EACE,sCAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;AALJ;AC/JE;EDgKA;IAOI,gBAAA;EAJJ;AACF","sourcesContent":["@import \"mixins\";\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n    width: 100%;\n  }\n  \n  .timezoneList {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .applyAllSection {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 12px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid var(--strokes-blue);\n  }\n  \n  .applyAllButton {\n    font: var(--typography-body-s-medium);\n  }\n  \n  .courseTimezoneRow {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n    background-color: var(--color-bg-light-blue);\n    border: 1px solid var(--strokes-blue);\n    border-radius: 10px;\n    transition: all 0.2s ease;\n    position: relative; // Add this to establish positioning context\n    overflow: visible; // Ensure overflow is visible for dropdown\n  \n    @include md {\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      padding: 20px;\n    }\n  \n  }\n\n  .dropdownContainer {\n    width: 100%;\n    flex-shrink: 0; // Prevent dropdown from shrinking\n    \n    @include md {\n      width: 280px;\n      flex-shrink: 0;\n    }\n  }\n  \n  .courseInfo {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0; // Add this - allows flex item to shrink below content size\n    overflow: hidden; // Add this\n  }\n  \n  .courseName {\n    margin: 0;\n    font: var(--typography-body-m-medium);\n    color: var(--color-black);\n    overflow: hidden; // Add this\n    text-overflow: ellipsis; // Add this\n    white-space: nowrap; // Add this\n  }\n  \n  .timezoneSelect {\n    width: 100%;\n    padding: 10px 12px;\n    font: var(--typography-body-m-regular);\n    color: var(--color-black);\n    background-color: var(--color-white);\n    border: 1px solid var(--strokes-blue);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    outline: none;\n  \n    @include md {\n      min-width: 260px;\n      width: auto;\n    }\n  \n    &:hover:not(:disabled) {\n      border-color: var(--color-accent-blue);\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n  \n    &:focus,\n    &:focus-visible {\n      outline: none;\n      border-color: var(--color-accent-blue);\n      box-shadow: 0 0 0 3px rgba(91, 130, 243, 0.1);\n    }\n  \n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      background-color: var(--color-bg-light-blue);\n    }\n  }\n  \n  // Style the option elements\n  .timezoneOption {\n    padding: 8px;\n    font: var(--typography-body-s-regular);\n  }\n  \n  .formActions {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  \n    @include md {\n      gap: 16px;\n      margin-top: 16px;\n    }\n  }\n  \n  .confirmButton {\n    width: 100%;\n  }\n  \n  .skipButton {\n    width: 100%;\n  }\n  \n  // Loading state\n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    font: var(--typography-body-m-regular);\n    color: var(--color-text-secondary);\n  }\n  \n  // Empty state\n  .emptyState {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    text-align: center;\n    gap: 16px;\n    padding: 40px 20px;\n  }\n  \n  .emptyStateText {\n    font: var(--typography-body-m-regular);\n    color: var(--color-text-secondary);\n  }\n  \n  // Helper text\n  .helperText {\n    font: var(--typography-body-s-regular);\n    color: var(--color-text-secondary);\n    margin-top: 8px;\n    text-align: center;\n  \n    @include md {\n      text-align: left;\n    }\n  }","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__cRsLO`,
	"timezoneList": `styles_timezoneList__Smth6`,
	"applyAllSection": `styles_applyAllSection__xDFWa`,
	"applyAllButton": `styles_applyAllButton__5ubPN`,
	"courseTimezoneRow": `styles_courseTimezoneRow__0oZll`,
	"dropdownContainer": `styles_dropdownContainer__YhMNh`,
	"courseInfo": `styles_courseInfo__cX1cA`,
	"courseName": `styles_courseName__G-uzb`,
	"timezoneSelect": `styles_timezoneSelect__CL8jc`,
	"timezoneOption": `styles_timezoneOption__coh2g`,
	"formActions": `styles_formActions__yImUJ`,
	"confirmButton": `styles_confirmButton__pKc9f`,
	"skipButton": `styles_skipButton__X-8OZ`,
	"loading": `styles_loading__pLxc2`,
	"emptyState": `styles_emptyState__hqI1j`,
	"emptyStateText": `styles_emptyStateText__rdT1x`,
	"helperText": `styles_helperText__Ij5tv`
};
export default ___CSS_LOADER_EXPORT___;
